const API_ENDPOINT = `${process.env.API_URL}/client`;

export const API_KEYBOARD = `${API_ENDPOINT}/security/accesstokens/keyboard`;
export const API_RENEW_SIGNATURE = `${API_ENDPOINT}/security/signature`;